import { Controller } from "stimulus"
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export default class extends Controller {
  static targets = ["phone", "email", "form", "contactType", "secondaryPhone"]

  initialize() {
    // validations
    this.addContactForm = this.addContactForm();
    // set up listeners
    this.focusOnModal();
  }

  focusOnModal() {
    //focuses on modal when it is shown
    //required for screen readers
    var modal = document.getElementById('addContactModal');
    modal.addEventListener('shown.bs.modal', function() {
      var firstInput = this.querySelector('#addContactForm input.form-control');
      if (firstInput) {
          firstInput.focus();
      }
  });
  }

  submitContactForm() {
    document.getElementById("addContactSubmit").disabled = true;
    this.addContactForm.validate().then(function (status) { 
      if (status == 'Valid') {
        document.getElementById("addContactForm").submit();
      } else {
        document.getElementById("addContactSubmit").disabled = false;
      }
    });
  }

  phoneOrEmailPresent() {
    return this.phoneTarget.value?.length > 0 || this.emailTarget.value?.length > 0
  }

  addContactForm(){
    let self = this;
    return FormValidation.formValidation(
      document.getElementById('addContactForm'),
      {
        fields: {
          contactName: {
            selector: '[name="contact_form[name]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Full name is required'
              },
              stringLength: {
                max: 255,
                message: 'Full name must be less than 255 characters'
              }
            }
          },
          contactPreferredName: {
            selector: '[name="contact_form[preferred_name]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Preferred name is required'
              },
              stringLength: {
                max: 255,
                message: 'Preferred name must be less than 255 characters'
              }
            }
          },
          reference: {
            selector: '[name="contact_form[reference]"]',
            validators: {
              stringLength: {
                max: 255,
                message: 'Reference must be less than 255 characters'
              }
            }
          },
          email: {
            selector: '[name="contact_form[email]"]',
            validators: {
              emailAddress: {
                message: 'Please enter valid email'
              },
              stringLength: {
                max: 255,
                message: 'Email must be less than 255 characters'
              },
              facilitatorEmailPresent: {
                message: 'Email is required for facilitators',
                callback: function(input) {
                  return document.getElementById('newContactRoles-facilitator').checked ? input.value?.length > 0 : true
                }
              },
              emailOrPhonePresent: {
                message: 'Phone or email must be present',
                callback: function() {
                  return document.getElementById('newContactRoles-facilitator').checked || self.phoneOrEmailPresent()
                }
              }
            }
          },
          phone: {
            selector: '[name="contact_form[phone]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Phone number is required'
              },
              checkValidNumber: {
                message: 'Please enter a valid number',
                callback: function(input) {
                  return input.value.length == 0 || isValidPhoneNumber(input.value, 'GB')
                }
              },
              emailOrPhonePresent: {
                message: 'Phone or email must be present',
                callback: function() {
                  return document.getElementById('newContactRoles-facilitator').checked || self.phoneOrEmailPresent()
                }
              }
            }
          },
          secondaryPhone: {
            selector: '[name="contact_form[secondary_phone]"]',
            validators: {
              checkValidNumber: {
                message: 'Please enter a valid number',
                callback: function(input) {
                  return input.value.length == 0 || isValidPhoneNumber(input.value, 'GB')
                }
              }
            }
          },
          contactRoles: {
            selector: '[name="contact_form[contact_roles][]"]',
            validators: {
              choice: {
                min: 1,
                message: 'Please select at least one role for this contact'
              }
            }
          },
          notes: {
            selector: '[name="contact_form[notes]"]',
            validators: {
              stringLength: {
                max: 30000,
                message: 'Notes must be less than 30,000 characters'
              }
            }
          }
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger(),
          bootstrap5: new Bootstrap5({
            rowSelector: '.g-5'
          }),
          alias: new FormValidation.plugins.Alias({
            checkValidNumber: 'callback',
            emailOrPhonePresent: 'callback',
            facilitatorEmailPresent: 'callback'
          }),
          autoFocus: new AutoFocus(),
          submitButton: new FormValidation.plugins.SubmitButton(),
          aria: new FormValidation.plugins.Aria(),
          trigger: new FormValidation.plugins.Trigger(
            {
              event: 'input',
              threshold: 1,
              delay: 1

            }
          ),
      },
    })
  }

}